import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import { toast } from 'sonner';
import Layout from '../components/Layout';
import axios from 'axios';

const Settings = () => {
  const [password, setPassword] = useState("");
  const [authorized, setAuthorized] = useState(false);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSettings = async () => {
    try {
      // First check auth by trying to fetch logs or just standard
      // But here we need to protect settings GET? Ideally yes, but for MVP maybe public GET is okay for frontend rendering, 
      // but let's assume we fetch on load.
      // Wait, server.py GET /settings is public (no auth param). That's fine for public pages.
      // For editing we need auth.
      
      const res = await axios.get(`${BACKEND_URL}/api/settings`);
      setSettings(res.data);
      setAuthorized(true); // Simple client-side gate for now, real protection is on PUT
    } catch (e) {
      console.error(e);
    }
  };

  const handleLogin = (e) => {
      e.preventDefault();
      // Verify password against env in backend? 
      // We can reuse the admin regs endpoint to verify password
      axios.get(`${BACKEND_URL}/api/admin/registrations?password=${password}`)
        .then(() => {
            setAuthorized(true);
            fetchSettings();
        })
        .catch(() => toast.error("Invalid Password"));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
        await axios.put(`${BACKEND_URL}/api/settings?password=${password}`, settings);
        toast.success("Settings Updated Successfully");
    } catch(e) {
        toast.error("Failed to update settings");
    } finally {
        setLoading(false);
    }
  };

  const handleChange = (e) => {
      const { name, value } = e.target;
      setSettings(prev => ({...prev, [name]: value}));
  };

  useEffect(() => {
      // Only fetch if authorized? Or fetch for public fields? 
      // Let's require login first.
  }, []);

  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold mb-8 text-primary">Event Settings</h1>

        {!authorized ? (
          <div className="max-w-md mx-auto bg-white p-6 rounded shadow border">
            <label className="block mb-2 font-bold">Admin Password</label>
            <form onSubmit={handleLogin} className="flex gap-2">
              <input 
                type="password" 
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="flex-1 border p-2 rounded"
              />
              <button type="submit" className="bg-primary text-white px-4 py-2 rounded">Login</button>
            </form>
          </div>
        ) : settings && (
          <div className="bg-white p-8 rounded shadow border">
             <form onSubmit={handleSave} className="space-y-6">
                
                <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                        <label className="font-bold">Event Title</label>
                        <input name="event_title" value={settings.event_title} onChange={handleChange} className="w-full border p-2 rounded" />
                    </div>
                    <div className="space-y-2">
                        <label className="font-bold">Guru Name</label>
                        <input name="guru_name" value={settings.guru_name} onChange={handleChange} className="w-full border p-2 rounded" />
                    </div>
                    <div className="space-y-2">
                        <label className="font-bold">Dates</label>
                        <input name="dates" value={settings.dates} onChange={handleChange} className="w-full border p-2 rounded" />
                    </div>
                    <div className="space-y-2">
                        <label className="font-bold">Time</label>
                        <input name="time" value={settings.time} onChange={handleChange} className="w-full border p-2 rounded" />
                    </div>
                    <div className="space-y-2">
                        <label className="font-bold">Fee (INR)</label>
                        <input type="number" name="fee" value={settings.fee} onChange={handleChange} className="w-full border p-2 rounded" />
                    </div>
                    <div className="space-y-2">
                        <label className="font-bold">WhatsApp Group Link</label>
                        <input name="whatsapp_group_link" value={settings.whatsapp_group_link} onChange={handleChange} className="w-full border p-2 rounded" />
                    </div>
                </div>

                <div className="border-t pt-6">
                    <h3 className="text-xl font-bold mb-4 text-secondary">Bank Details</h3>
                    <div className="grid md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                            <label className="font-bold">Account No</label>
                            <input name="bank_account_no" value={settings.bank_account_no} onChange={handleChange} className="w-full border p-2 rounded" />
                        </div>
                        <div className="space-y-2">
                            <label className="font-bold">IFSC</label>
                            <input name="bank_ifsc" value={settings.bank_ifsc} onChange={handleChange} className="w-full border p-2 rounded" />
                        </div>
                        <div className="space-y-2">
                            <label className="font-bold">Account Name</label>
                            <input name="bank_name" value={settings.bank_name} onChange={handleChange} className="w-full border p-2 rounded" />
                        </div>
                        <div className="space-y-2">
                            <label className="font-bold">UPI ID</label>
                            <input name="upi_id" value={settings.upi_id} onChange={handleChange} className="w-full border p-2 rounded" />
                        </div>
                        <div className="space-y-2">
                            <label className="font-bold">Support Phone</label>
                            <input name="support_phone" value={settings.support_phone} onChange={handleChange} className="w-full border p-2 rounded" />
                        </div>
                    </div>
                </div>

                <button 
                  type="submit" 
                  disabled={loading}
                  className="w-full bg-primary text-white py-3 rounded font-bold hover:bg-primary/90"
                >
                    {loading ? "Saving..." : "Save Settings"}
                </button>
             </form>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Settings;
